import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import * as _ from 'underscore';

export interface SelectionCheckbox {
  type: string;
  filterType: string;
  searchValue?: string;
  selectedValue?: string[];
}

@Component({
    selector: 'app-multiselect-search',
    templateUrl: './multiselect-search.component.html',
    styleUrls: ['./multiselect-search.component.scss'],
    standalone: false
})

export class MultiselectSearchComponent implements OnInit {

  @Input() typeaheadLists;
  @Output('searchInput') searchInput: EventEmitter<SelectionCheckbox> = new EventEmitter<SelectionCheckbox>();
  filterMultipleData: string;
  checkedOptions: any[] = [];
  @Input() filtertype: string;
  searchText: UntypedFormControl = new UntypedFormControl('');
  displayedLists: any = []; // Filtered + sorted list shown in UI
  selected: any = []
  @Input() events: Observable<void>;
  @Input() searchClear;
  chipsSelected: any = [];
  @Input() filterSelectList: any;


  constructor() {
  }

  ngOnInit() {
    console.log('filter select list - ', this.filterSelectList);
    this.checkedOptions = this.filterSelectList || [];
    if(this.checkedOptions?.length) {
      this.selected = this.typeaheadLists.filter(item => this.checkedOptions.includes(item.key));
      this.sortedTypeaheadLists();
    }
    this.events?.subscribe((res: any) => {
      if (res.status == 'searchClear') {
        this.searchText.setValue('');
        this.displayedLists = [];
        // this.checkedOptions = [];
        // this.displayedLists = [];
        this.sortedTypeaheadLists();
      } else if (res.status == 'clearAll') {
        this.checkedOptions = [];
        this.selected = [];
        this.searchText.setValue('');
        this.displayedLists = [];
        this.sortedTypeaheadLists();
      }
    })

  }


ngOnChanges(changes: SimpleChanges): void {

  if (changes.filterSelectList) {
    this.checkedOptions = [...(this.filterSelectList || [])];

    this.selected = this.typeaheadLists?.filter(item =>
      this.checkedOptions.includes(item.key)
    ) || [];

    this.sortedTypeaheadLists();
  }

  if (changes.typeaheadLists && this.typeaheadLists?.length) {
    this.sortedTypeaheadLists();
  }
}

  onTypeSearch(event) {
    const input = event;
    this.searchText.setValue(input);
    this.searchInput.emit({ type: 'search', searchValue: input, filterType: this.filtertype });
    this.sortedTypeaheadLists();
  }

  selectMultipleData(event, option) {
    if (event.target.checked == true) {
      if (!this.checkedOptions.includes(option.key)) {

        this.checkedOptions.push(option.key);
        this.selected.push(option);

      }
    } else {
      this.checkedOptions = _.without(this.checkedOptions, option.key);
      this.selected = this.selected.filter(x => x.key != option.key);
    }
    this.sortedTypeaheadLists();
  }

  applyFilters() {
    this.searchText.setValue('');
    this.searchInput.emit({ type: 'apply', selectedValue: this.checkedOptions, filterType: this.filtertype });
  }

  resetFilters() {
    this.checkedOptions = [];
    this.selected = [];
    this.searchInput.emit({ type: 'reset', selectedValue: this.checkedOptions, filterType: this.filtertype });

  }

sortedTypeaheadLists() {

  this.selected = this.typeaheadLists.filter(item =>
    this.checkedOptions.includes(item.key)
  );

  const filtered = this.typeaheadLists.filter(item =>
    item.key.toLowerCase().includes((this.searchText.value || '').toLowerCase())
  );

  const unselected = filtered.filter(item =>
    !this.checkedOptions.includes(item.key)
  );

  this.displayedLists = [...this.selected, ...unselected];
}


}


